<template>
  <div :class="`trigger-container trigger-${id}`">
    <div class="heading">
      <span class="title" v-text="label"></span>
      <span class="link"
            v-if="toolLink"
            v-text="linkLabel"
            @click="change('DecisionAid')"
      ></span>
    </div>

    <div class="trigger-button" :class="{'disabled': toolLink}" @click="change(popup)">
      <span class="chosen-option" v-text="value"></span>
      <img class="icon" :src="getImage('pencil-blue.svg')">
    </div>
    <span class="error" v-if="error">{{ $t('hose.noCouplingSelected') }}</span>
  </div>
</template>

<script>
export default {
  name: "PopupTrigger",

  props: {
    label: {
      type: String,
    },
    toolLink: {
      type: Boolean,
      default: false,
    },
    linkLabel: {
      type: String,
    },
    value: {
      type: String,
    },
    id: {
      type: Number,
    },
    popup: {
      type: String,
    },
    error: Boolean,
  },

  methods: {
    change(newValue) {
      this.$emit('change', newValue);
      this.$emit('input', newValue);
    }
  }

}
</script>

<style scoped lang="scss">
.trigger-container {
  margin-left: 10px;
  width: 100%;
  max-width: 220px;

  .heading {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
      font-size: 14px;
      font-family: neue-haas-grotesk-display, sans-serif;
    }

    .link {
      font-size: 12px;
      font-family: neue-haas-grotesk-text, sans-serif;
      text-decoration: underline;
      cursor: pointer;
      transition: all ease 0.25s;

      &:hover {
        color: darken(#3DB0C7, 10%);
      }
    }
  }

  .trigger-button {
    border-radius: 50px;
    width: 100%;
    border: 2px solid #EBEBEB;
    display: flex;
    align-items: center;
    background-color: white;
    margin-top: 6px;
    transition: all ease 0.3s;
    max-height: 40px;
    padding: 12px 30px 12px 10px;
    font-size: 12px;
    font-family: neue-haas-grotesk-text, sans-serif;
    position: relative;
    justify-content: center;
    cursor: pointer;
    user-select: none;

    &.disabled {
      cursor: default;
      padding-left: 20px;

      &:hover {
        background-color: white;
      }
      .icon {
        display: none;
      }
    }

    &:hover {
      background-color: lighten(#3DB0C7, 40%);

      .icon {
        transform: scale(1.5);
      }
    }

    .icon {
      transition: all ease 0.3s;
      position: absolute;
      right: 8%;
    }

    .chosen-option {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .error {
    margin-left: 12px;
    color: #cc0000;
    font-size: 10px;
    font-style: italic;
  }
}
</style>